import { assign } from 'xstate';

import { generateDerivedModifiers } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Generates derived modifiers based on initial and active modification states.
 */
export const generateModifiers: CustomizationMachineAction = assign((args) => {
  const { modifications } = args.context;

  if (!modifications) return {};

  const { initial, active } = modifications;

  const modifiers = generateDerivedModifiers(initial, active);

  return { modifications: { ...modifications, ...modifiers } };
});
